// removed by extract-text-webpack-plugin
module.exports = {"logo":"app-aNqkLJnH","sider":"app-xedInhGQ","ligth":"app-rZm3dY9_","icon":"app-2K-WBvUX"};


//////////////////
// WEBPACK FOOTER
// ./src/wbap-mian-apps/wbap-admin-main/components/SiderMenu/index.less
// module id = 736
// module chunks = 0